module.exports = __webpack_public_path__ + "static/kathleen-barretto-headshot-38e2683e10b74e14f88c993884cc300f.jpg";